import types from '../../constants';

export function sendMessage(targets, message, options = {}) {
  return async (dispatch) => {
    if(options.contentType === 'audio') {
        if(targets.length === 0) {
        global.socket.emit('audio_message', { target: '', message, options }); 
      } else {
        targets.forEach((target) => {
          global.socket.emit('audio_message', { target, message });
        })
      }
      return;
    }
    if(targets.length === 0) {
      global.socket.emit('text_message', { target: '', message, options }); 
    } else {
      targets.forEach((target) => {
        global.socket.emit('text_message', { target, message });
      })
    }
    dispatch({ type: types.CBOX_CLEAR_INPUT });
  };
}

export function changeInput(value) {
  return {
    type: types.CBOX_CHANGE_INPUT,
    payload: value,
  };
}

export function selectUser(id) {
  return {
    type: types.CBOX_SELECT_USER,
    payload: id,
  };
}

export function deselectUser(id) {
  return {
    type: types.CBOX_DESELECT_USER,
    payload: id,
  };
}

export function deselectAllUsers() {
  return {
    type: types.CBOX_DESELECT_ALL_USER
  }
}
